<dt-modal-content (closeClick)="cancel()">
  <ng-template #title i18n>Besitzrechte an Veranstaltung übertragen</ng-template>
  <ng-template #content>
    <p i18n>Übertrage die Besitzrechte an der Veranstaltung auf einen anderen Nutzer. Du bist weiterhin Editor der Veranstaltung.</p>
    <mat-form-field>
      <mat-label i18n>E-Mail-Adresse des neuen Besitzers</mat-label>
      <input matInput [formControl]="newOwnerEmailForm" />
      @if (newOwnerEmailForm.errors?.required || newOwnerEmailForm.errors?.email) {
        <mat-error i18n>Keine gültige E-Mail-Adresse</mat-error>
      }
      @if (newOwnerEmailForm.errors?.unknownUser) {
        <mat-error i18n>Zu dieser E-Mail-Adresse existiert kein Benutzer</mat-error>
      }
    </mat-form-field>
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      color="accent"
      [disabled]="newOwnerEmailForm.invalid || newOwnerEmailForm.disabled"
      (click)="submit()"
      [dtOverlayProgress]="newOwnerEmailForm.disabled"
      i18n
      >Veranstaltung übertragen</button
    >
    <button mat-raised-button color="accent-less" [disabled]="newOwnerEmailForm.disabled" (click)="cancel()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
